module.exports = __webpack_public_path__ + "95607b7ea91ec67b187269ab976e91f8.pdf";